var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeokasmain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9617",
    "data-name": "Group 9617",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 23.739,
    viewBox: "0 0 160 23.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15599f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#36b6aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4a501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00afa8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.001,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15599f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#36b6aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b0a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#00b0a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.343,
    y1: 0.053,
    x2: 0.758,
    y2: 1.006,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fab720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07e25"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M2.138,0a1.538,1.538,0,0,1,.579.134,2.066,2.066,0,0,1,1.47,2c-.045.045-.045.178-.089.445a2.012,2.012,0,0,1-1.96,1.559H1.782A2.1,2.1,0,0,1,0,2.093a1.538,1.538,0,0,1,.134-.579A1.985,1.985,0,0,1,2.138,0M26.456,0a2.235,2.235,0,0,1,.624.134,2.134,2.134,0,0,1,1.47,1.96l-.045.178c-.267,1.024-2.227,7.3-5.834,18.884-.356,1.737-1.113,2.583-2.316,2.583a2.232,2.232,0,0,1-1.782-.98c-.223-.534-1.648-5.077-4.276-13.584h-.089C11.8,16.88,10.555,20.8,10.511,20.933c-.4,1.871-1.158,2.761-2.316,2.761A2.125,2.125,0,0,1,6.28,22.536c-2.227-7.26-3.385-11.045-3.385-11.268a2.714,2.714,0,0,1,.178-.757,2.17,2.17,0,0,1,1.96-1.336,2.219,2.219,0,0,1,1.737.98c.178.4.668,1.871,1.425,4.409H8.24c.045-.089,1.425-4.409,4.053-12.871A1.93,1.93,0,0,1,14.208,0a2.109,2.109,0,0,1,1.871,1.158l1.381,4.276c1.826,5.968,2.761,9,2.85,9.086h.045L24.407,1.6A2.139,2.139,0,0,1,26.456,0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M86.107,19.463a3.03,3.03,0,0,1,.668.089,2.08,2.08,0,0,1,1.6,1.96,2.556,2.556,0,0,1-.045.534,2.256,2.256,0,0,1-2.316,1.692h-11.4a2.326,2.326,0,0,1-.935-.178A2.1,2.1,0,0,1,72.3,21.6a1.835,1.835,0,0,0,.089-.4,2.127,2.127,0,0,1,2.227-1.692H86.107ZM74.482,9.754a1.538,1.538,0,0,1,.579.134,2.082,2.082,0,0,1,1.47,1.915,4.678,4.678,0,0,1-.089.579,2.08,2.08,0,0,1-1.96,1.6h-.089a3.7,3.7,0,0,1-.579-.089A2.143,2.143,0,0,1,72.3,11.847l.089-.445a2.145,2.145,0,0,1,2.049-1.648h.045Zm11.8,0a1.671,1.671,0,0,1,.445.045,2.085,2.085,0,0,1,1.648,2v.089a1.538,1.538,0,0,1-.134.579,2.066,2.066,0,0,1-2,1.47H80.361a1.671,1.671,0,0,1-.445-.045,2.085,2.085,0,0,1-1.648-2v-.134a1.371,1.371,0,0,1,.134-.579,2.025,2.025,0,0,1,2-1.425ZM86.062,0a4.441,4.441,0,0,1,.713.089,2.09,2.09,0,0,1,1.6,2,3.155,3.155,0,0,1-.045.624,2.244,2.244,0,0,1-2.227,1.559H74.616a3.972,3.972,0,0,1-.98-.134A2.218,2.218,0,0,1,72.3,2.182l.178-.713A2.114,2.114,0,0,1,74.616,0Z",
    transform: "translate(-38.897 0)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6958",
    "data-name": "Path 6958",
    d: "M130.831,22.537a1.931,1.931,0,1,1-1.931,1.931A1.868,1.868,0,0,1,130.831,22.537Z",
    transform: "translate(-74.564 -2.768)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6956",
    "data-name": "Path 6956",
    d: "M330.941,14.7a5.093,5.093,0,0,1,.38,1.927,6.681,6.681,0,0,1-2.891,5.6,8.635,8.635,0,0,1-11.487-1.547,7.005,7.005,0,0,1-1.344-3.956,2,2,0,0,1,1.927-1.927c3.271,0,.38,5.2,5.883,5.2,2.612,0,4.64-1.724,3.271-4.539a2.018,2.018,0,0,1-.279-.964,1.9,1.9,0,0,1,1.445-1.826c1.471-.558,2.536.964,3.094,2.029M316.006,9.02a5.093,5.093,0,0,1-.38-1.927,6.682,6.682,0,0,1,2.891-5.6A8.635,8.635,0,0,1,330,3.036a7.066,7.066,0,0,1,1.344,4.057A2,2,0,0,1,329.42,9.02c-3.271,0-.38-5.2-5.883-5.2-2.612,0-4.64,1.724-3.271,4.539a2.018,2.018,0,0,1,.279.964A1.9,1.9,0,0,1,319.1,11.15C317.629,11.632,316.488,9.984,316.006,9.02Zm7.43.685a2.13,2.13,0,1,1-2.13,2.13A2.212,2.212,0,0,1,323.435,9.705Z",
    transform: "translate(-171.347 0.009)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6957",
    "data-name": "Path 6957",
    d: "M207.57,23.735a1.841,1.841,0,0,0,1.07.2,2.493,2.493,0,0,0,1.248-.688c.1-.1.1-.2.2-.28L218.42,6.415l4.355,8.507a1.8,1.8,0,0,0,1.732,1.07,1.886,1.886,0,0,0,1.656-.968,1.816,1.816,0,0,0,0-1.834L220.254,1.372A2.006,2.006,0,0,0,218.522.2a1.976,1.976,0,0,0-1.732,1.172L206.7,21.137a2.149,2.149,0,0,0-.2,1.07,2,2,0,0,0,1.07,1.528m20.81-3.77a1.936,1.936,0,1,1-1.936,1.936A1.844,1.844,0,0,1,228.379,19.965Z",
    transform: "translate(-91.945 -0.2)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    d: "M130.831.163a1.93,1.93,0,0,1,1.931,1.931V6.158a1.931,1.931,0,1,1-3.861,0V1.992A1.911,1.911,0,0,1,130.831.163m0,15.75a1.93,1.93,0,0,1,1.931,1.931v4.064a1.931,1.931,0,1,1-3.861,0V17.843A1.93,1.93,0,0,1,130.831,15.912Zm0-5.792a1.931,1.931,0,1,1-1.931,1.931A1.868,1.868,0,0,1,130.831,10.121Zm4.445-.584a1.9,1.9,0,0,0,2.718,0l6.173-6.1a1.9,1.9,0,0,0,0-2.718,1.9,1.9,0,0,0-2.718,0l-6.173,6.1A1.858,1.858,0,0,0,135.276,9.536Zm0,4.928a1.9,1.9,0,0,1,2.718,0l6.173,6.1a1.922,1.922,0,0,1-2.718,2.718l-6.173-6.1A1.859,1.859,0,0,1,135.276,14.464Z",
    transform: "translate(-36.141 -0.15)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9616",
    "data-name": "Group 9616",
    transform: "translate(63.244 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    d: "M24.283,0A11.871,11.871,0,0,1,36.171,11.888v.762a2.151,2.151,0,0,1-1.829,1.169,2.1,2.1,0,0,1-1.931-1.346v-.584a8.027,8.027,0,1,0-16.054,0A7.79,7.79,0,0,0,18.389,17.2a2.238,2.238,0,0,1-.864,2.413,2.2,2.2,0,0,1-2.032.1,11.978,11.978,0,0,1-3-7.824A11.721,11.721,0,0,1,24.283,0",
    transform: "translate(-12.494 0)",
    fill: "#f07e25",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7054",
    "data-name": "Path 7054",
    d: "M24.388,34.957A11.871,11.871,0,0,1,12.5,23.068v-.762a2.313,2.313,0,0,1,1.931-1.067,2.1,2.1,0,0,1,1.931,1.346v.584a8.027,8.027,0,1,0,16.054,0,7.79,7.79,0,0,0-2.032-5.309,2,2,0,0,1,.864-2.413,1.8,1.8,0,0,1,1.931-.2,11.839,11.839,0,0,1-8.789,19.712",
    transform: "translate(-12.499 -11.23)",
    fill: "url(#linear-gradient-7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeokasmain);
export default __webpack_public_path__ + "static/media/weokasmain.083e04bdcb5577053f50875d6dd1b835.svg";
export { ForwardRef as ReactComponent };